/* eslint-disable @typescript-eslint/no-explicit-any */
import {  HttpErrorResponse, HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { Observable, map } from 'rxjs'

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
   constructor() {}

   intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      return next
         .handle(request)
         .pipe(
            map((event: HttpEvent<any>): any => {
               if (event.type === HttpEventType.Response) {
                  if (event.body?.error) {
                     throw new HttpErrorResponse( event.body )
                  }
               }
               return event
            })
         )
   }
}
